import script from "./LoginEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginEvento.vue?vue&type=script&setup=true&lang=js"

import "./LoginEvento.vue?vue&type=style&index=0&id=5a0d51de&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0d51de"]])

export default __exports__